import cx from 'classnames'

import { ReactComponent as PhraseeSecondaryLogo } from 'common/icons/phraseeLogo/secondary.svg'

type Props = {
  className?: string
}

const Footer = ({ className }: Props) => {
  return (
    <div
      className={cx(
        `py-12 flex justify-center items-center text-coolGray-300`,
        className
      )}
    >
      <PhraseeSecondaryLogo width={36} height={58} />
    </div>
  )
}

export default Footer
